<template>
  <div class="home_box">
    <div class="content">
        <div ref="file"></div>
    </div>
    <div class="confirm" v-if="false">
      <div class="sp_btn" style="color:#999;" v-if="false">取消申请</div>
      <div class="sp_btn" style="color:red;" @click="$router.push('/home')">确认申请</div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
const docx = require('docx-preview');
window.JSZip = require('jszip')
export default {
  data() {
    return {
      registerForm: {
        name: "",
        gender: "",
        age: "",
        city: "",
        job: "",
        work_mode: "",
        mobile: "",
        email: "",
        resource: "",
        exp: ""
      },
      text:''
    };
  },
  mounted(){
    axios({
      method: 'get',
      responseType: 'blob', // 设置响应文件格式
      url: '/hongfei-page/privacy-page/front_static/user.docx',
    }).then(({data}) => {
      docx.renderAsync(data,this.$refs.file) // 渲染到页面预览
    })
  },
  
};
</script>

<style lang="less" scoped>
pre{
  white-space:pre-wrap; /* css3.0 /
  white-space:-moz-pre-wrap; / Firefox /
  white-space:-pre-wrap; / Opera 4-6 /
  white-space:-o-pre-wrap; / Opera 7 /
  word-wrap:break-word; / Internet Explorer 5.5+ */
}
.home_box {
  position: relative;
  padding-bottom: 50px;
  .content{
      text-align: left;
      >div{
          padding-bottom:20px;
      }
  }
  .confirm {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: space-evenly;
    .sp_btn {
      width: 120px;
      height:3em;
      text-align: center;
      padding: 10px 15px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #666;
      letter-spacing: 1.5px;
      border-radius: 90px;
      box-shadow: 1.2px 1.2px 5px -3px rgba(0, 0, 0, 0.6),
        -0.1px -0.1px 5px -3px rgba(0, 0, 0, 0.1);
    }
    
  }
}
/deep/.docx-wrapper{
  padding:0 !important;
  >.docx{
    padding:10pt 5pt !important;
  }
}
/deep/.docx-wrapper section.docx{
  box-shadow:none !important;
}
</style>